import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import IndexPageLayout from '../templates/index-page-layout';
import Heading from '../controls/heading-control';
import MainContent from '../components/main-content';
import FeaturedImage from '../components/featured-image';
import BigSearch from '../controls/big-search-control';
import HomeParagraph from '../controls/home-paragraph-control';
import AuxiliaryContent from '../components/auxiliary-content';
import Footer from '../components/footer';
import { InlineLinkDarkControl as InlineLink } from '../controls/inline-link-control';
import HomeReadMore from '../controls/home-read-more';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = IndexPageLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <MainContent mdxType="MainContent">
      <Heading mdxType="Heading">Calculating a levy estimate in the MSA Levy Area</Heading>
      <HomeParagraph mdxType="HomeParagraph">
        <p>{`This tool will calculate a levy estimate for a selected parcel(s) of freehold land, or a Crown land area when using shapefiles, and identify any overlapping conservation area(s).`}</p>
        <HomeReadMore mdxType="HomeReadMore" />
      </HomeParagraph>
    </MainContent>
    <BigSearch mdxType="BigSearch"></BigSearch>
    <FeaturedImage mdxType="FeaturedImage"></FeaturedImage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      